const mutations = {
    saveUsers: (state, payload) => {
        state.users = payload.data;
    }
};

export default mutations

